import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bed-icon.png'
import _imports_1 from '@/assets/icons/bath-icon.png'
import _imports_2 from '@/assets/icons/guest-icon.png'
import _imports_3 from '@/assets/icons/pet-icon.png'
import _imports_4 from '@/assets/icons/nopet-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-043fa20e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-height":"25px","margin":"10px"},
  src: _imports_0
}, null, -1))
const _hoisted_2 = { style: {"margin-right":"10px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-height":"25px","margin":"10px"},
  src: _imports_1
}, null, -1))
const _hoisted_4 = { style: {"margin-right":"10px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-height":"25px","margin":"10px"},
  src: _imports_2
}, null, -1))
const _hoisted_6 = { style: {"margin-right":"10px"} }
const _hoisted_7 = {
  key: 0,
  style: {"max-height":"25px","margin":"10px"},
  src: _imports_3
}
const _hoisted_8 = {
  key: 1,
  style: {"max-height":"25px","margin":"10px"},
  src: _imports_4
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"200px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, { style: {"font-family":"'Montserrat', sans-serif","font-weight":"700","text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode("Property Info")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { style: {"--background":"white"} }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, { style: {"padding-right":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item['name']), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.item['address']['short_name'] != null && _ctx.item['address']['short_name'] != '')
              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.locationSharp }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.item['address']['short_name']), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item['bedrooms']), 1),
                _hoisted_3,
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item['baths']), 1),
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item['max_guests']), 1),
                (_ctx.item['pets_allowed'])
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", _hoisted_8))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_9
      ]),
      _: 1
    }),
    _createVNode(_component_ion_grid, {
      class: "ldx-bottom-fixed",
      style: {"padding":"0px","margin":"0px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { style: {"padding":"0px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  style: {"width":"100%","height":"100%","margin":"0px"},
                  expand: "full",
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Back")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}